import React, { useEffect, useState } from 'react';
import FormCommandeView from './FormCommande.view';
import usePublicShop from '../../../../hooks/usePublicShop';
import { useMutation } from '@apollo/client';
import { AppState } from 'store/reducers';
import useGoToPage from '../../../../hooks/useGoToPage';
import {
  clearCart as clearCartAction,
  updateFraisPort
} from '../../../../store/actions/panier.actions';
import {
  addClient as addClientAction,
  clearClient as clearClientAction
} from '../../../../store/actions';
import pages from '../../../../routes/pages';
import {
  AddCommandesAndNoteMutation,
  AddCommandesAndNoteMutationVariables,
  AddPublicOrderMutation,
  AddPublicOrderMutationVariables
} from '../../../../graphql/generated/graphql';
import { ADD_PUBLIC_ORDER } from '../../../../graphql/mutation/publicOrder';
import callBackOrder from './callBackOrder';
import { CREATE_COMMANDE } from '../../../../graphql/mutation/commande/createCommande.mutation';
import { PanierState } from '../../../../types/panier/panier.def';
import { MainFormState } from '../../../../types/forms/form.def';
import callBackPublicOrder from './callBackPublicOrder';
import formatOrderForMutation from '../../../../helpers/shop/formatOrderForMutation';
import { useDispatch, useSelector } from 'react-redux';

interface FormCommandeProps {
  panier: PanierState;
}

export const FormCommande = ({ panier }: FormCommandeProps) => {
  const { isPublicShop, shopId, classeId } = usePublicShop();
  const [loading, setLoading] = useState(false);
  const goToCommandePage = useGoToPage(pages.MES_COMMANDES_PAGE.path);

  const { client } = useSelector((state: AppState) => state);
  const dispatch = useDispatch();

  const clearCart = () => dispatch(clearCartAction);
  const clearClient = () => dispatch(clearClientAction);
  const addClient = (newParams: MainFormState<any>) =>
    dispatch(addClientAction(newParams));
  const updateFraisDePort = (isPortApplicable: boolean) =>
    dispatch(updateFraisPort(isPortApplicable));

  useEffect(() => {
    if (isPublicShop) {
      addClient({
        ...client,
        values: { ...client.values, affilie: true, methodepaiement: 'cb' }
      });
      updateFraisDePort(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [addPublicOrder] = useMutation<
    AddPublicOrderMutation,
    AddPublicOrderMutationVariables
  >(
    ADD_PUBLIC_ORDER,
    callBackPublicOrder(clearClient, clearCart, setLoading, shopId)
  );

  const [createCommande] = useMutation<
    AddCommandesAndNoteMutation,
    AddCommandesAndNoteMutationVariables
  >(
    CREATE_COMMANDE,
    callBackOrder(clearClient, clearCart, goToCommandePage, setLoading)
  );

  const submit = async () => {
    setLoading(true);
    const order = formatOrderForMutation(client.values, panier);

    if (isPublicShop) {
      return await addPublicOrder({
        variables: {
          order: order,
          shopId: shopId,
          classeId: classeId
        }
      });
    } else {
      return await createCommande({
        variables: {
          order
        }
      });
    }
  };

  return (
    <FormCommandeView
      loading={loading}
      client={client}
      isPublicShop={isPublicShop}
      submit={submit}
    />
  );
};
